<template>
  <ol
    class="sn-select-content"
    :style="containerWidth"
  >
    <div
      class="clear-answer"
      v-if="showClearButton"
      :class="{
        'small': !tall
      }"
      @click="optionCleared"
    >
      <label v-text="$t('multiselect.select')">
      </label>
    </div>

    <component
      :is="optionTemplates[displayType]"
      :class="{
        'small': !tall
      }"
      v-for="(option, index) in optionList"
      :key="index"
      :option-data="option"
      :settings="optionSettings"
      @optionSelected="optionSelected"
    />

    <div
      class="no-result"
      v-if="!hasOptions"
      :class="{
        'small': !tall
      }"
    >
      <label v-text="$t('multiselect.noResults')">
      </label>
    </div>
  </ol>
</template>

<script>
  import * as _ from 'lodash'

  import Locales from '../../../../localization/Locales'

  import OptionTemplateDefault from './option-templates/OptionTemplateDefault'
  import OptionTemplateUser from './option-templates/OptionTemplateUser'

  export default {
    name: 'SNSelectContent',
    components: {
    },

    i18n: {
      messages: Locales
    },

    data () {
      return {
        optionTemplates: {
          'default': OptionTemplateDefault,
          'user': OptionTemplateUser
        }
      }
    },
    props: {
      displayType: {
        default: 'default',
        type: String
      },
      containerWidth: {
        default: function () {
          return {}
        },
        type: Object
      },
      options: {
        default: function () {
          return []
        },
        type: Array
      },
      settings: {
        default: function () {
          return {
            displayKey: 'Name',
            showColor: false,
            tall: true,
            singleSelect: false,
            showHiddenOptions: false
          }
        },
        type: Object
      }
    },
    methods: {
      optionSelected (filteredOption) {
        let self = this
        self.$emit('optionSelected', filteredOption)
      },
      optionCleared () {
        let self = this
        self.$emit('clearOption')
      }
    },
    computed: {
      optionList () {
        let self = this
        let result = self.options

        if (!self.showHiddenOptions) {
          result = _.reject(result, { 'hidden': true })
        }

        return result
      },
      selectionCount () {
        let self = this
        let selectedOptions = _.filter(self.options, { 'selected': true })
        return _.size(selectedOptions)
      },
      hasOptions () {
        let self = this
        return _.size(self.optionList) > 0
      },
      optionSettings () {
        let self = this
        return self.settings
      },
      singleSelect () {
        let self = this
        let result = true

        if (self.settings) {
          result = self.settings.singleSelect
        }

        return result
      },
      showClearButton () {
        let self = this
        let result = false

        if (self.settings && !self.settings.required) {
          result = self.singleSelect && self.hasOptions && (self.selectionCount > 0)
        }

        return result
      },
      tall () {
        let self = this
        let result = true

        if (self.settings) {
          result = self.settings.tall
        }

        return result
      },
      showHiddenOptions () {
        let self = this
        let result = false

        if (self.settings) {
          result = self.settings.showHiddenOptions
        }

        return result
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../uikit';

  input {
    font-size: 14px;
  }

  .sn-select-content {
    font-size: 14px;
    position: relative;
    box-sizing: border-box;
    width: inherit;
    height: auto;
    max-height: 150px;
    overflow: auto;
    margin: 0;
    background-color: white;
    list-style-type: none;
    padding: 0;

    li {
      height: 50px;
      line-height: 50px;

      &.small {
        height: 25px;
        line-height: 25px;
      }
    }

    .clear-answer,
    .no-result {
      height: 50px;
      line-height: 50px;
      padding-left: 10px;

      label {
        cursor: inherit;
        font-size: 14px;
        color: $lightGreyFont;
        font-style: italic;
      }

      &.small {
        height: 25px;
        line-height: 25px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/sns-components/kit-components/input-templates/selection/SNSelectContent.vue